<script setup>
import { scrollToTitle } from "@/composables/commonFunction.js";
const seoTitle = "MIRASOFT - Design";
const seoDescription = "";


useHead({
    title: seoTitle,
    meta: [
        { name: "description", content: seoDescription },
        { name: "og:title", content: seoTitle },
        { name: "og:description", content: seoDescription },
        { name: "keywords", content: "Design" },
    ],
});

const listTag = [
    {
        title: "Ui/ux",
    },
    {
        title: "app Development",
    },
    {
        icon: "/images/cube-1.svg",
    },
    {
        title: "design",
    },
    {
        title: "Graphic",
    },
    {
        icon: "/images/abstract-1.svg",
    },
    {
        title: "illustration",
    },
    {
        title: "branding",
    }
];
</script>

<template>
    <div class="home-page px-12 max-md:px-6 py-10">
        <section id="about-us" class="2xl:container m-auto max-md:pt-4">
            <div class="max-sm:hidden" data-aos="fade-up">
                <nuxt-picture loading="lazy" src="/images/banner/frame-88.png"
                    :imgAttrs="{ class: 'w-full', alt: 'home-banner' }" class="w-full" />
            </div>
            <div class="sm:hidden -mx-4" data-aos="fade-up">
                <nuxt-picture loading="lazy" src="/images/banner/frame-89.png"
                    :imgAttrs="{ class: 'w-full', alt: 'home-banner-mobile' }" class="w-full" />
            </div>
        </section>

        <section class="mt-[80px] 2xl:container m-auto max-md:mt-10" id="ui-ux-design">
            <section class="mt-[80px] 2xl:container m-auto max-md:mt-10" data-aos="fade-up">
                <div
                    class="flex max-lg:flex-col max-md:items-center gap-[141px] max-lg:gap-0 max-2xl:gap-10 rounded-3xl p-10 max-lg:p-5 max-md:pb-0 mb-10 bg-white ">
                    <div
                        class="w-[60%] bg-white rounded-3xl overflow-hidden pt-[62px] pl-[30px] max-lg:pl-0 max-lg:pb-0 pb-[20px] relative max-xl:p-4 max-lg:w-full">
                        <div class="flex max-md:flex-col gap-[32px] items-center max-md:items-start">
                            <div class="max-lg:hidden">
                                <nuxt-picture loading="lazy" src="/images/shape.svg" width="60px"
                                    :imgAttrs="{ alt: 'icon' }" />
                            </div>
                            <div class="hidden max-lg:block">
                                <nuxt-picture loading="lazy" src="/images/shape-1.svg" width="60px"
                                    :imgAttrs="{ alt: 'icon' }" />
                            </div>
                            <p class="uppercase text-[32px] font-bold mt-[8px] max-md:text-[24px]">
                                Steppen - Beauty & Health App
                            </p>
                        </div>
                        <div class="pt-[10px] max-md:pt-[20px] font-medium text-[16px] uppercase max-md:text-[12px]">
                            UI/UX Design - Branding
                        </div>
                        <div class="max-md:ml-0 text-justify">
                            <p class="text-[18px] text-black mt-[40px] max-md:mt-5 max-md:text-[14px]">
                                Steppen is a dynamic & fast-moving start-up keeping the
                                mission of making fitness a habit for millions of young
                                people. Since its introduction in June 2021, the Steppen
                                App has garnered over 330,000 app store downloads and is
                                now the #1 Fitness App Made For Gen Z.
                            </p>
                            <p class="text-[18px] text-black mt-[25px] max-md:mt-2 max-md:text-[14px]">
                                Ohio Digital's Gen Z designers, whilst with our young
                                customers, can empathize and put ourselves in the shoes of
                                users to create the best solution to assist them in leading a
                                healthier lifestyle: a tailored fitness experience.
                            </p>
                            <p class="text-[18px] text-black mt-[25px] max-md:mt-2 max-md:text-[14px]">
                                We invested our attempts in adding more color, more fun,
                                and more customization to reach GenZ's favor, then better motivate them.
                            </p>
                        </div>
                    </div>
                    <div class="w-[40%] bg-white rounded-3xl overflow-hidden p-10 relative max-xl:p-4 max-lg:w-full">
                        <div class="flex gap-[32px] w-full max-lg:hidden">
                            <nuxt-picture loading="lazy" src="/images/group-90.png"
                                :imgAttrs="{ class: 'w-full', alt: 'icon' }" class="w-full" />
                        </div>
                    </div>
                </div>

                <div class="w-full hidden max-lg:block border-2 p-6 bg-white rounded-3xl overflow-hidden border-white">
                    <nuxt-picture loading="lazy" src="/images/group-90.png"
                        :imgAttrs="{ class: 'w-full', alt: 'icon' }" />
                </div>
            </section>

            <section class="mt-[80px] 2xl:container m-auto max-md:mt-10">
                <div class="flex max-lg:flex-col max-md:items-center gap-4">
                    <div class="w-[55%] bg-white rounded-3xl overflow-hidden p-16 relative max-xl:p-4 max-lg:w-full"
                        data-aos="fade-right">
                        <div class="flex max-md:flex-col gap-[32px] items-center max-md:items-start">
                            <nuxt-picture loading="lazy" src="/images/lllustration-shapes.svg" width="60px"
                                :imgAttrs="{ alt: 'icon' }" />
                            <p class="uppercase text-[32px] max-md:text-[24px] font-semibold">ReciMe</p>
                        </div>
                        <div class="pt-[10px] font-medium max-md:text-[12px] text-[16px] uppercase">UI/UX Design</div>
                        <div class="text-justify">
                            <p class="text-[18px] max-md:text-[14px] text-black pt-[40px] max-md:pt-5 ">
                                ReciMe is a fast growing start-up with the huge ambition to democratize the global
                                cooking
                                industry and to build the
                                largest community of cooks in the world. Today, there are
                                2000 people using ReciMe to share and discover recipes from each other. In the next 5
                                years,
                                they want to make that
                                100M people...and more!
                            </p>
                            <p class="text-[18px] max-md:text-[14px] text-black pt-[20px]">
                                Ohio Digital tweaked the color scheme to express a vibrant,
                                contemporary, and inspiring mood.
                            </p>
                            <p class="text-[18px] max-md:text-[14px] text-black pt-[20px]">
                                To create a less corporate, fun & exciting style, we decided
                                to utilize 2 new fonts: Recoleta & Poppins with 200+ unique
                                icons. ReciMe gets a fresh look by our updated style guide,
                                key assets, and symbols. In addition, we generate 70+
                                wireframes and noticeable UI add-ins.
                            </p>
                        </div>
                    </div>
                    <div class="w-[45%] max-lg:w-full rounded-3xl overflow-hidden max-md:mt-3" data-aos="fade-left">
                        <div>
                            <nuxt-picture loading="lazy" src="/images/img-7.png" class="w-full picture"
                                :imgAttrs="{ class: 'w-full max-xl:h-full max-2xl:h-[450px]', alt: 'cammera' }" />
                        </div>
                        <div class="flex max-lg:flex-col gap-4 mt-4 max-md:mt-7">
                            <div class="w-full max-lg:w-full bg-[#F67D30] p-6 rounded-3xl" data-aos="fade-up"
                                data-aos-delay="300">
                                <div class="flex flex-wrap gap-2 mt-1 ml-[10px]">
                                    <div v-for="tag in listTag">
                                        <div v-if="tag.title"
                                            class="border boroder-[#0B0B0B] max-md:px-[18px] px-[27.5px] py-[10.5px] rounded-3xl uppercase">
                                            <p class="text-white text-[14px] max-md:text-[12px] font-semibold">
                                                {{ tag.title }}
                                            </p>
                                        </div>
                                        <div v-else
                                            class="w-[42px] h-[42px] rounded-[50%] border boroder-[#0B0B0B] flex justify-center items-center">
                                            <nuxt-picture loading="lazy" :src="tag.icon" width="100%"
                                                :imgAttrs="{ alt: 'icon' }" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </section>

        <section class="mt-[80px] 2xl:container m-auto max-md:mt-10" data-aos="fade-up" id="e-commerce-web-design">
            <div class="flex max-lg:flex-col max-md:items-center rounded-3xl max-md:pb-5 mb-10 bg-white ">
                <div
                    class="w-[57%] bg-white rounded-3xl overflow-hidden pt-[62px] pl-[64px] max-lg:pb-0 pb-[33px] relative max-xl:p-4 max-lg:w-full">
                    <div class="flex max-md:flex-col gap-[30px] items-center max-md:items-start">
                        <nuxt-picture loading="lazy" src="/images/group-57.svg" width="60px"
                            :imgAttrs="{ alt: 'icon' }" />
                        <p class="uppercase text-[32px] font-bold mt-[8px] max-md:text-[24px] w-full">
                            ECOMMERCE WEBSITE FOR A LEADING FASTENERS AND FITTING MANUFACTURER
                        </p>
                    </div>
                    <div class="pt-[10px] max-md:pt-[20px] font-medium text-[16px] uppercase max-md:text-[12px]">
                        UI/UX Design
                    </div>
                    <div class="">
                        <h4 class="text-black mt-[35px] uppercase">Technologies</h4>
                        <p class="text-[18px] text-black max-md:mt-2 mt-3 max-md:text-[14px]">
                            The client’s sales process was replying solely on salespeople and catalogue printouts. Yet,
                            the impact of the COVID-19 pandemic has made their offline sales decrease dramatically.
                        </p>
                    </div>
                    <div class="">
                        <h4 class="text-black mt-[35px] uppercase">Scope of Work</h4>
                        <p class="text-[18px] text-black max-md:mt-2 mt-3 max-md:text-[14px]">
                            Mirasoft has built a Magento 2 E-Commerce website to sell 100,000 SKUs on the website and
                            helped the to simplify the ir complex sales cycle of salespeople - quotation - buyer -
                            negotiation. Once products are added to the ‘quotation cart’, user just need one click to
                            submit. A quotation from the sales team will be sent to user's email. User can access My
                            Account to Print or Checkout from My Quotation section
                        </p>
                    </div>
                </div>
                <div
                    class="w-[43%] bg-white rounded-3xl overflow-hidden p-10 max-lg:pt-0 max-2xl:pt-24 relative max-xl:p-4 max-lg:w-full">
                    <div class="flex gap-[32px] w-full max-lg:hidden">
                        <nuxt-picture loading="lazy" src="/images/image-3.png"
                            :imgAttrs="{ class: 'w-full', alt: 'icon' }" class="w-full" />
                    </div>
                </div>
            </div>

            <div class="w-full hidden max-lg:block border-2 bg-white rounded-3xl overflow-hidden border-white">
                <nuxt-picture loading="lazy" src="/images/image-3.png" :imgAttrs="{ class: 'w-full', alt: 'icon' }" />
            </div>
        </section>

        <section class="mt-[80px] 2xl:container m-auto max-md:mt-8" id="ui-packaging">
            <div class="flex max-lg:flex-col max-md:items-center gap-4">
                <div class="w-[45%] max-lg:w-full rounded-3xl overflow-hidden max-lg:order-1 max-md:mt-4"
                    data-aos="fade-right">
                    <nuxt-picture loading="lazy" src="/images/img-8.png" class="w-full picture"
                        :imgAttrs="{ class: 'w-full', alt: 'cammera' }" />
                </div>
                <div class="w-[55%] bg-white rounded-3xl overflow-hidden p-[64px] relative max-xl:p-4 max-lg:w-full"
                    data-aos="fade-left">
                    <div class="flex max-md:flex-col gap-[32px] items-start">
                        <nuxt-picture loading="lazy" src="/images/shapes.svg" width="60px"
                            :imgAttrs="{ alt: 'icon' }" />
                        <p class="uppercase font-bold text-[32px] max-md:text-[24px]">
                            SHIFTCAM
                        </p>
                    </div>
                    <div
                        class="pb-[18px] font-medium text-[16px] mt-3 uppercase max-md:text-[12px] max-md:mt-4 max-xl:mt-5">
                        UI & Packaging
                    </div>
                    <div class="mt-[62px] max-xl:mt-0 max-2xl:mt-[35px]">
                        <div class="text-justify">
                            <p class="text-[18px] text-black pt-[10px] max-md:text-[14px] max-md:pt-0">
                                <strong class="text-[18px] max-md:text-[14px]">ShiftCam</strong> is a group of
                                photographers, designers,
                                engineers, and operation folks who had a vision. That
                                vision is of taking mobile photography to a whole new
                                level through a variety of cool gadgets and accessories
                                for aspiring photographers with nothing but a phone.
                            </p>
                            <p class="text-[18px] text-black pt-[30px] max-md:text-[14px] max-md:pt-4">
                                Ohio Digital provided a constant stream of effective
                                marketing assets, online and offline, on a regular basis as
                                well as for specific events.
                            </p>
                            <p class="text-[18px] text-black pt-[30px] max-md:text-[14px] max-md:pt-4">
                                Along with contemporary web pages for regular and
                                event specific uses, we delivered packaging design for
                                their latest products.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <Excellence class="mt-[80px]" />
    </div>
</template>
